export const DISTRIBUTION_BASE_URL = "https://langx.jp";

// URL utilities
export function getDistributionUrl(classCode?: string | null): string {
  if (!classCode) {
    return DISTRIBUTION_BASE_URL;
  }
  return `${DISTRIBUTION_BASE_URL}/${classCode}`;
}

export function getDistributionUrlWithoutProtocol(classCode: string): string {
  return `${DISTRIBUTION_BASE_URL.replace("https://", "")}/${classCode}`;
}

// Clipboard utilities
export async function copyToClipboard(
  text: string,
  successMessage: string,
  errorMessage: string,
  emitFn: (event: string, data: { message: string; color: string }) => void,
): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    emitFn("showSnackbar", {
      message: successMessage,
      color: "success",
    });
  } catch (error) {
    console.error("Error copying to clipboard:", error);
    emitFn("showSnackbar", {
      message: errorMessage,
      color: "error",
    });
  }
}
